module.exports = {
    apiServerUrl: 'https://127.0.0.1:3000',
    publicHostname: 'https://app.dev.my-collaborate.com',
    websocketHostname: 'https://127.0.0.1:3000',
    debug: true,
    logLevel: 'debug',
    logFilter: 'myc:*',
};
